import { render, staticRenderFns } from "./AccreditationDetail.vue?vue&type=template&id=a88b509e&scoped=true"
import script from "./AccreditationDetail.vue?vue&type=script&lang=js"
export * from "./AccreditationDetail.vue?vue&type=script&lang=js"
import style0 from "./AccreditationDetail.vue?vue&type=style&index=0&id=a88b509e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a88b509e",
  null
  
)

export default component.exports